// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavIconUploader-space1-jKxXy {
	margin-bottom: 6px !important;
}

.FavIconUploader-space2-tGm2h {
	margin-bottom: 12px !important;
}

.FavIconUploader-space3-zfXJo {
	margin-bottom: 18px !important;
}

.FavIconUploader-space4-JDtIe {
	margin-bottom: 24px !important;
}

.FavIconUploader-space5-Ao5Wf {
	margin-bottom: 30px !important;
}

.FavIconUploader-space6-_4cBF {
	margin-bottom: 36px !important;
}

.FavIconUploader-space7-hzsRI {
	margin-bottom: 42px !important;
}

.FavIconUploader-spaceTop8-pBBNn {
	margin-bottom: 48px !important;
}

.FavIconUploader-spaceTop1-C2OER {
	margin-top: 6px !important;
}

.FavIconUploader-spaceTop2-j5uac {
	margin-top: 12px !important;
}

.FavIconUploader-spaceTop3-L8vpW {
	margin-top: 18px !important;
}

.FavIconUploader-spaceTop4-OCGFh {
	margin-top: 24px !important;
}

.FavIconUploader-spaceTop5-nnYRV {
	margin-top: 30px !important;
}

.FavIconUploader-spaceTop6-kgdx7 {
	margin-top: 36px !important;
}

.FavIconUploader-spaceTop7-v2Jyv {
	margin-top: 42px !important;
}

.FavIconUploader-spaceTop8-pBBNn {
	margin-top: 48px !important;
}

.FavIconUploader-noMargin-JLe6T {
	margin: 0px !important;
}

.FavIconUploader-padding1-u4Ll9 {
	padding-bottom: 6px !important;
}

.FavIconUploader-padding2-WmwKp {
	padding-bottom: 12px !important;
}

.FavIconUploader-padding3-SLqjx {
	padding-bottom: 18px !important;
}

.FavIconUploader-padding4-ae8IC {
	padding-bottom: 24px !important;
}

.FavIconUploader-padding5-hNiVo {
	padding-bottom: 30px !important;
}

.FavIconUploader-padding6-yQxpI {
	padding-bottom: 36px !important;
}

.FavIconUploader-padding7-y5Vl1 {
	padding-bottom: 42px !important;
}

.FavIconUploader-paddingTop1-xwO7T {
	padding-top: 6px !important;
}

.FavIconUploader-paddingTop2-AFiDt {
	padding-top: 12px !important;
}

.FavIconUploader-paddingTop3-CiD37 {
	padding-top: 18px !important;
}

.FavIconUploader-paddingTop4-wIksR {
	padding-top: 24px !important;
}

.FavIconUploader-paddingTop5-gn1m7 {
	padding-top: 30px !important;
}

.FavIconUploader-paddingTop6-HnjfR {
	padding-top: 36px !important;
}

.FavIconUploader-paddingTop7-i39BF {
	padding-top: 42px !important;
}

.FavIconUploader-noPadding-o6LJB {
	padding: 0px !important;
}

.FavIconUploader-textBold-DqvQJ {
	font-weight: 500 !important;
}

.FavIconUploader-textBolder-UnttG {
	font-weight: 700 !important;
}

.FavIconUploader-textNormal-UPZ_6 {
	font-weight: normal !important;
}

.FavIconUploader-spaceBottom20-YSZrl {
	margin-bottom: 20px;
}

.FavIconUploader-spaceBottom10-AB1ky {
	margin-bottom: 10px;
}

.FavIconUploader-marginNone-k_gVi {
	margin: 0;
}

.FavIconUploader-spaceBottom15-i_OOk {
	margin-bottom: 15px;
}

.FavIconUploader-marginTopNone-ndR0_ {
	margin-top: 0;
}

.FavIconUploader-spaceTop11-qT6Hz {
	margin-top: 11px;
}

.FavIconUploader-spaceTop21-z95CM {
	margin-top: 21px;
}

.FavIconUploader-spaceTop20-cFDB4 {
	margin-top: 20px;
}

.FavIconUploader-spaceTop10-DeDDB {
	margin-top: 10px;
}

/*New Design Text Colors */

.FavIconUploader-textDarkBlue-cJwuk {
	color: rgb(20, 39, 94) !important;
}

.FavIconUploader-textLightBlue-UxKtD {
	color: rgb(57, 87, 106) !important;
}

.FavIconUploader-textLightSandleGreen-OUKM7 {
	color: rgb(76, 86, 41) !important;
}

.FavIconUploader-textLightBrown-LpACE {
	color: rgb(115, 79, 33) !important;
}

.FavIconUploader-textMediumMaroon-Mk95I {
	color: rgb(87, 37, 51) !important;
}

.FavIconUploader-textBrown-xTnRO {
	color: rgb(160, 47, 24) !important;
}

.FavIconUploader-textMaroon-M3RaO {
	color: rgb(155, 49, 67) !important;
}

.FavIconUploader-textDarkBrown-Lunmc {
	color: rgb(83, 18, 16) !important;
}

.FavIconUploader-textMediumBrown-E_aTx {
	color: rgb(142, 28, 10) !important;
}

.FavIconUploader-textSkyBlue-xK9VN {
	color: rgb(37, 117, 141) !important;
}

.FavIconUploader-textGray-IWsUR {
	color: rgb(77, 65, 51) !important;
}

.FavIconUploader-pngFontSize-k9PV_ {
    font-size: 15px;
    position: absolute;
    bottom: -42px;
    right: 17px;
}

.FavIconUploader-positionRelative-RLYXa {
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/SiteSettingsForm/FavIconUploader/FavIconUploader.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../helpers.css';\n\n.pngFontSize {\n    font-size: 15px;\n    position: absolute;\n    bottom: -42px;\n    right: 17px;\n}\n\n.positionRelative {\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `FavIconUploader-space1-jKxXy`,
	"space2": `FavIconUploader-space2-tGm2h`,
	"space3": `FavIconUploader-space3-zfXJo`,
	"space4": `FavIconUploader-space4-JDtIe`,
	"space5": `FavIconUploader-space5-Ao5Wf`,
	"space6": `FavIconUploader-space6-_4cBF`,
	"space7": `FavIconUploader-space7-hzsRI`,
	"spaceTop8": `FavIconUploader-spaceTop8-pBBNn`,
	"spaceTop1": `FavIconUploader-spaceTop1-C2OER`,
	"spaceTop2": `FavIconUploader-spaceTop2-j5uac`,
	"spaceTop3": `FavIconUploader-spaceTop3-L8vpW`,
	"spaceTop4": `FavIconUploader-spaceTop4-OCGFh`,
	"spaceTop5": `FavIconUploader-spaceTop5-nnYRV`,
	"spaceTop6": `FavIconUploader-spaceTop6-kgdx7`,
	"spaceTop7": `FavIconUploader-spaceTop7-v2Jyv`,
	"noMargin": `FavIconUploader-noMargin-JLe6T`,
	"padding1": `FavIconUploader-padding1-u4Ll9`,
	"padding2": `FavIconUploader-padding2-WmwKp`,
	"padding3": `FavIconUploader-padding3-SLqjx`,
	"padding4": `FavIconUploader-padding4-ae8IC`,
	"padding5": `FavIconUploader-padding5-hNiVo`,
	"padding6": `FavIconUploader-padding6-yQxpI`,
	"padding7": `FavIconUploader-padding7-y5Vl1`,
	"paddingTop1": `FavIconUploader-paddingTop1-xwO7T`,
	"paddingTop2": `FavIconUploader-paddingTop2-AFiDt`,
	"paddingTop3": `FavIconUploader-paddingTop3-CiD37`,
	"paddingTop4": `FavIconUploader-paddingTop4-wIksR`,
	"paddingTop5": `FavIconUploader-paddingTop5-gn1m7`,
	"paddingTop6": `FavIconUploader-paddingTop6-HnjfR`,
	"paddingTop7": `FavIconUploader-paddingTop7-i39BF`,
	"noPadding": `FavIconUploader-noPadding-o6LJB`,
	"textBold": `FavIconUploader-textBold-DqvQJ`,
	"textBolder": `FavIconUploader-textBolder-UnttG`,
	"textNormal": `FavIconUploader-textNormal-UPZ_6`,
	"spaceBottom20": `FavIconUploader-spaceBottom20-YSZrl`,
	"spaceBottom10": `FavIconUploader-spaceBottom10-AB1ky`,
	"marginNone": `FavIconUploader-marginNone-k_gVi`,
	"spaceBottom15": `FavIconUploader-spaceBottom15-i_OOk`,
	"marginTopNone": `FavIconUploader-marginTopNone-ndR0_`,
	"spaceTop11": `FavIconUploader-spaceTop11-qT6Hz`,
	"spaceTop21": `FavIconUploader-spaceTop21-z95CM`,
	"spaceTop20": `FavIconUploader-spaceTop20-cFDB4`,
	"spaceTop10": `FavIconUploader-spaceTop10-DeDDB`,
	"textDarkBlue": `FavIconUploader-textDarkBlue-cJwuk`,
	"textLightBlue": `FavIconUploader-textLightBlue-UxKtD`,
	"textLightSandleGreen": `FavIconUploader-textLightSandleGreen-OUKM7`,
	"textLightBrown": `FavIconUploader-textLightBrown-LpACE`,
	"textMediumMaroon": `FavIconUploader-textMediumMaroon-Mk95I`,
	"textBrown": `FavIconUploader-textBrown-xTnRO`,
	"textMaroon": `FavIconUploader-textMaroon-M3RaO`,
	"textDarkBrown": `FavIconUploader-textDarkBrown-Lunmc`,
	"textMediumBrown": `FavIconUploader-textMediumBrown-E_aTx`,
	"textSkyBlue": `FavIconUploader-textSkyBlue-xK9VN`,
	"textGray": `FavIconUploader-textGray-IWsUR`,
	"pngFontSize": `FavIconUploader-pngFontSize-k9PV_`,
	"positionRelative": `FavIconUploader-positionRelative-RLYXa`
};
module.exports = ___CSS_LOADER_EXPORT___;
